import {
  VEHICLE_ZONES_LOADING,
  FETCH_VEHICLE_ZONES,
  DELETE_VEHICLE_ZONE,
  UPDATE_VEHICLE_ZONE,
  CREATE_VEHICLE_ZONE,
} from '../actions/vehicleZones';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_VEHICLE_ZONES:
      return {
        ...state,
        vehicleZones: action.payload,
      };
    case VEHICLE_ZONES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CREATE_VEHICLE_ZONE:
    case DELETE_VEHICLE_ZONE:
    case UPDATE_VEHICLE_ZONE:
    default:
      return state;
  }
}
